const TEXTS = {
  LOG_OUT: {
    LABEL: 'Log Out',
    DESCRIPTION: 'Are you sure you want to log out?',
    CANCEL: 'Cancel',
  },
};

export { TEXTS };
